export default "__VITE_ASSET__iZhz26HL__"